import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    horizontalContainerWrapper: {
      '@media(min-width: 1600px)': {
        maxWidth: 1440,
      },
    },
    // Skeleton
    rootSkeleton: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      gap: Spacings.s72,
    },
  },
  {
    name: 'new-home-root',
  },
);

export default useStyles;
